import React, { Component } from "react";
import PropTypes from "prop-types";
import Layout from "../Layout";
import { Layout8 } from "../ContentBox";
import { DivHover, DivHelp } from "./styled";

class IconButtonView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false
    };
  }
  onHover = () => {
    this.setState({ hover: true });
  };
  onMouseOver = () => {
    this.setState({ hover: false });
  };
  render() {
    return (
      <DivHover
        onMouseLeave={this.onMouseOver.bind(this)}
        onMouseEnter={this.onHover.bind(this)}
      >
        <Layout {...this.props} type="IconButtonView" />
        {this.state.hover && <DivHelp>Content</DivHelp>}
      </DivHover>
    );
  }
}

IconButtonView.propTypes = {
  childOf: PropTypes.string,
  values: PropTypes.object,
  layout: PropTypes.func
};

IconButtonView.defaultProps = {
  childOf: "Content",
  values: {
    parent: "Content",
    type: "IconButtonView",
    containerPadding: "0px",
    disabled: false,
    buttonAlign: "center",
    buttonColors: {
      color: "#FFF",
      backgroundColor: "#e61919",
      hoverColor: "#42d696"
    },
    size: "small",
    tooltip: "tooltip",
    tooltipPosition: "top-right",
    icon: "home",
    href: {
      url: "",
      target: ""
    }
  },
  layout: Layout8
};
export default IconButtonView;



// WEBPACK FOOTER //
// ./src/editor/layout/components/Content/IconButtonView.js